class BonsaiTicketForm extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.quantityInput = this.querySelector('[data-ticket-quantity]');
    this.minusButton = this.querySelector('[data-ticket-minus]');
    this.plusButton = this.querySelector('[data-ticket-plus]');
    this.submitButton = this.querySelector('[data-ticket-submit]');
    this.errorMessage = this.querySelector('[data-ticket-error]');

    if (!this.quantityInput || !this.submitButton) return;

    try {
      this.variants = JSON.parse(this.querySelector('[data-ticket-variants]')?.textContent || '[]');
    } catch (_error) {
      this.variants = [];
    }

    this.max = Math.min(Number(this.dataset.maxAdd) || 0, this.variants.length, 4);
    this.quantity = 1;

    this.minusButton?.addEventListener('click', () => this.setQuantity(this.quantity - 1));
    this.plusButton?.addEventListener('click', () => this.setQuantity(this.quantity + 1));
    this.submitButton.addEventListener('click', () => this.addTickets());

    this.updateControls();
  }

  setQuantity(nextQuantity) {
    this.quantity = Math.max(1, Math.min(this.max, nextQuantity));
    this.updateControls();
  }

  updateControls() {
    this.quantityInput.value = String(this.quantity);
    if (this.minusButton) this.minusButton.disabled = this.quantity <= 1;
    if (this.plusButton) this.plusButton.disabled = this.quantity >= this.max;
    this.submitButton.textContent = `Add ${this.quantity} ${this.quantity === 1 ? 'ticket' : 'tickets'} to cart`;
  }

  async addTickets() {
    if (this.max < 1 || this.quantity < 1) return;

    this.submitButton.disabled = true;
    this.submitButton.textContent = 'Adding tickets…';
    if (this.errorMessage) this.errorMessage.hidden = true;

    const items = this.variants.slice(0, this.quantity).map(({ id }) => ({
      id,
      quantity: 1,
      properties: { _event_ticket: 'Bonsai Workshop 2026' },
    }));

    try {
      const response = await fetch(this.dataset.cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Those tickets could not be added.');
      }

      window.location.assign(this.dataset.cartUrl);
    } catch (error) {
      this.submitButton.disabled = false;
      this.updateControls();
      if (this.errorMessage) {
        this.errorMessage.textContent = `${error.message} Please refresh the page and try again.`;
        this.errorMessage.hidden = false;
      }
    }
  }
}

if (!customElements.get('bonsai-ticket-form')) {
  customElements.define('bonsai-ticket-form', BonsaiTicketForm);
}
